export default {
    callingAPI: false,
    searching: '',
    userProfile: JSON.parse(localStorage.getItem('vuex'))?.userProfile || {},
    token: JSON.parse(localStorage.getItem('vuex'))?.token || '',
    status:'',
    userInfo: {
        messages: [],
        notifications: [],
        tasks: []
    },
    events: [],
    weekendsVisible: true,
    hide_scroll:false,
    empId: JSON.parse(localStorage.getItem('vuex'))?.empId || '',
    userId: JSON.parse(localStorage.getItem('vuex'))?.userId || '',
    page:'dashboard',
    isMultiple:JSON.parse(localStorage.getItem('vuex'))?.isMultiple == 1 ? true : false,
    company_setting:JSON.parse(localStorage.getItem('vuex'))?.company_setting || {},
    photo_profile:JSON.parse(localStorage.getItem('vuex'))?.photo_profile || null,
    menus:JSON.parse(localStorage.getItem('vuex'))?.menus || [],
    routes:JSON.parse(localStorage.getItem('vuex'))?.routes || []
}